import type { LeadFormState, LeadSubmission, UtmParams } from '../types/lead.js';
import { PAGE_VERSION } from '../config/collectionsLanding.js';

/** A blank form state. Pure - safe to import in Node tests. */
export function emptyForm(): LeadFormState {
  return {
    invoicing_platform: '',
    invoicing_platform_other: '',
    payment_methods: [],
    payment_method_other: '',
    collection_pains: [],
    current_workaround: '',
    current_workaround_other: '',
    biggest_pain_text: '',
    monthly_request_volume: '',
    open_balance_range: '',
    price_commitment: 'join_at_29',
    price_expectation: '',
    first_name: '',
    business_name: '',
    email: '',
    mobile: '',
    business_type: '',
    consent: true,
    company_website: '',
  };
}

/** Build the API payload from form state + tracking metadata. Pure. */
export function buildSubmission(state: LeadFormState, utm: UtmParams): LeadSubmission {
  return {
    first_name: state.first_name.trim(),
    business_name: state.business_name.trim(),
    email: state.email.trim(),
    mobile: state.mobile.trim(),
    business_type: state.business_type.trim(),
    invoicing_platform: state.invoicing_platform,
    invoicing_platform_other: state.invoicing_platform_other.trim(),
    payment_methods: state.payment_methods,
    payment_method_other: state.payment_method_other.trim(),
    collection_pains: state.collection_pains,
    current_workaround: state.current_workaround,
    current_workaround_other: state.current_workaround_other.trim(),
    biggest_pain_text: state.biggest_pain_text.trim(),
    monthly_request_volume: state.monthly_request_volume,
    open_balance_range: state.open_balance_range,
    price_commitment: state.price_commitment,
    price_expectation: state.price_expectation,
    consent: state.consent,
    page_version: PAGE_VERSION,
    company_website: state.company_website,
    ...utm,
  };
}
